module.exports = __webpack_public_path__ + "static/media/project-management.a0f0c680.png";